var utils = require('./extrax2-webadmin.utils.js');
var ajax = require('./extrax2-webadmin.ajax.js');
var initialize = require('./extrax2-webadmin.initialize.js');

function validatorMethods() {

	$.validator.prototype.resetForm = function () {
		if ($.fn.resetForm) {
			$(this.currentForm).resetForm();
		}
		$(this.currentForm)[0].reset();
		this.submitted = {};
		this.lastElement = null;
		this.prepareForm();
		this.hideErrors();
		var elements = this.elements().removeData("previousValue").removeAttr("aria-invalid");
		if (this.settings.unhighlight) {
			for (var i = 0; elements[i]; i++) {
				this.settings.unhighlight.call(this, elements[i], this.settings.errorClass, this.settings.validClass);
			}
		}
	}

	$.validator.addMethod(
		"minNonAlpha",
		function (value, element, param) {

			var count = 0;
			var array = value.split("");
			jQuery.each(array, function (i, val) {
				if (!/^[a-zA-Z]+$/.test(val)) {
					count++;
				}
			});
			return this.optional(element) || count >= param;
		},
		Lang.get('extrax2-webadmin.field_non_alpha', { "min": "{0}" })
	);

	$.validator.addMethod(
		"validText",
		function (value, element, param) {
			var valid = true;

			var pattern = new RegExp("^[" + param + "]+$");
			var array = value.split("");
			jQuery.each(array, function (i, val) {
				if (pattern.test(val)) {
					valid = false;
					return;
				}
			});

			pattern = null;
			return this.optional(element) || valid;
		},
		Lang.get('extrax2-webadmin.no_valid_text', { "characters": "{0}" })
	);

	$.validator.addMethod(
		"validUsername",
		function (value, element) {

			if (/^[-_\.]+$/.test(value)) {
				return false;
			}

			return this.optional(element) || /^[a-zA-Z0-9-_\.]+$/.test(value);
		},
		Lang.get('extrax2-webadmin.no_valid_username')
	);

	$.validator.addMethod(
		"validSerialNumber",
		function (value, element) {

			var result = true;
			var valueList = $(element).select2().val();
			if (!utils.isUndefined(valueList)) {
				jQuery.each(valueList, function (i, val) {
					if (val.length !== 19) {
						result = false;
						return false;
					}
					var sumEven = 0;
					var sumOdd = 0;
					var checkNumberEven = 0;
					var checkNumberOdd = 0;

					for (i = 0; i < val.length; i++) {
						var char = val.substr(i, 1);
						var intChar = parseInt(char);
						if (isNaN(intChar)) {
							result = false;
							return false;
						}
						if (i === 17) {
							checkNumberOdd = intChar;
						}
						else if (i === 18) {
							checkNumberEven = intChar;
						}
						else if (((i + 1) % 2) === 0) {
							sumEven += intChar;
						}
						else {
							sumOdd += intChar;
						}
					}

					if ((checkNumberEven !== (sumEven % 10)) || (checkNumberOdd !== (sumOdd % 10))) {
						result = false;
						return false;
					}
				});
			}

			return this.optional(element) || result;
		},
		Lang.get('extrax2-webadmin.invalid_serial_number')
	);

	$.validator.addMethod(
		"validBsnrLanr",
		function (value, element) {

			var result = false;
			if (value === '' || value === '*' || (value.length === 9 && /^[0-9]*$/.test(value))) {
				result = true;
			}

			return this.optional(element) || result;
		},
		'TODO'
	);

	$.validator.addMethod(
		"minOneFullBsnrOrLanr",
		function (value, element) {

			var result = true;
			if (element.name === 'bsnr') {
				if (value === '*' && $(element).parents('form').find('[name="lanr"]').val() === '*')
				result = false;
			} else if (element.name === 'lanr') {
				if (value === '*' && $(element).parents('form').find('[name="bsnr"]').val() === '*')
					result = false;
			}

			return this.optional(element) || result;
		},
		Lang.get('extrax2-webadmin.min_one_full_bsnr_or_lanr')
	);

	$.validator.addMethod(
		"checkForMainLanrBsnr",
		function (value, element) {
			var valid = true;
			if ($('[name="charging_by"][value="account_id"]').is(':checked')) {
				var account_id_array = {};
				$.each($(element).parents('.mt-element-list').find('[name^="lanr_bsnr_account_id_"]:not([type=hidden])'), function (i, accountIdElement) {
					if (!($(accountIdElement).val() in account_id_array)) {
						account_id_array[$(accountIdElement).val()] = false;
					}
					if ($(accountIdElement).parents('.input-group').find('[name^="main_lanr_bsnr_"]').is(':checked')) {
						account_id_array[$(accountIdElement).val()] = true;
					}
				});

				$.each(account_id_array, function(accountId, value) {
					if (!value) {
						valid = false;
						return false;
					}
				});
			}
			return valid;
		},
		Lang.get('extrax2-webadmin.set_main_lanr_bsnr_for_all_account_ids')
	);

	$.validator.addMethod(
		"checkForMainBsnr",
		function (value, element) {
			var valid = true;
			if (($('[name="charging_by"][value="lanr"]').is(':checked') || $('[name="charging_by"][value="bsnr"]').is(':checked')) && $.inArray($('[name="check_for_main_bsnr"]').val(), ['2a', '2b', '3a', '3b', '4a', '4b']) !== -1) {
				valid = $(element).parents('.mt-element-list').find('[name^="main_lanr_bsnr_"]:checked').length;
			}
			return valid;
		},
		Lang.get('extrax2-webadmin.set_main_bsnr')
	);

	$.validator.addMethod(
		"customMethod",
		function (value, element) {
			var attrAction = element.getAttribute('data-action');
			if (utils.isUndefined(attrAction)) {
				return false;
			}

			var data = null;
			var attrOrigValue = element.getAttribute('data-orig-value');
			if (!utils.isUndefined(attrOrigValue)) {
				data = "origValue=" + encodeURIComponent(attrOrigValue);
			}
			var attrAdditionalValue = element.getAttribute('data-additional-value');
			if (!utils.isUndefined(attrAdditionalValue)) {
				if (data === null) {
					data = data + "&additionalValue="
				} else {
					data = "additionalValue=";
				}
				if ($(attrAdditionalValue).hasClass('tt-select2')) {
					data = data + encodeURIComponent($(attrAdditionalValue).select2().val());
				} else {
					data = data + encodeURIComponent($(attrAdditionalValue).val());
				}
			}

			return $.validator.methods.remote.call(this, value, element, {
				url: attrAction + "/" + value,
				data: data
			});
		},
		''
	);

	$.validator.addMethod(
		"validDateRange",
		function (value, element, param) {
			var valid = true;

			var date_from = null;
			if ($(element).parents('form').find(param[0]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
				date_from = $(element).parents('form').find(param[0]).data('picker').getDate();
			}
			var date_till = null;
			if ($(element).parents('form').find(param[1]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
				date_till = $(element).parents('form').find(param[1]).data('picker').getDate();
			}

			if (!utils.isUndefined(date_from) && !utils.isUndefined(date_till)
				&& date_from > date_till)
			{
				return false;
			}

			return true;
		},
		Lang.get('extrax2-webadmin.invalid_date_range')
	);

	$.validator.addMethod(
		"maxDate",
		function (value, element, param) {

			var date = $(element).data('picker').getDate();

			if (!utils.isUndefined(date) && date > param) {
				return false;
			}

			return true;
		},
		'TODO'
	);

	$.validator.addMethod(
		"minDate",
		function (value, element, param) {

			var date = $(element).data('picker').getDate();
			var minDate = utils.stringToDate($(element).data().minValue);

			if (!utils.isUndefined(date) && !utils.isUndefined(minDate) && date < minDate) {
				return false;
			}

			return true;
		},
		'TODO'
	);

	$.validator.addMethod(
		"requireFromGroup",
		function (value, element, param) {
			var valid = false;

			var elements = $(element).parents('form').find(param[1]);

			var counter = 0;
			jQuery.each(elements, function (i, val) {
				if ($(val).is('.tt-validation-checkbox,.md-check')) {
					if ($(val)[0].checked) {
						counter++;
					}
				} else if ($(val).is('.tt-select2')) {
					if (!utils.isUndefined($(val).select2().val()) && ($(val).select2().val().length > 1 || ($(val).select2().val().length === 1 && $(val).select2().val()[0] !== ''))) {
						counter++;
					}
				} else if ($(val).is('.datepicker')) {
					var picker = $(val).data('picker');
					var dateValue = utils.dateToString(picker.getDate());
					if (dateValue !== '') {
						counter++;
					}
				} else {
					if ($(val).val() !== '') {
						counter++;
					}
				}
			});

			if (counter >= param[0]) {
				valid = true;
			}

			return valid;
		},
		Lang.get('extrax2-webadmin.element_from_group_is_required')
	);

	$.validator.addMethod(
		"requireFromGroupWhenElementFilled",
		function (value, element, param) {

			var valid = true;

			var elements = $(element).parents('.tt-content-dialog,.tt-content-detail').find(param[0]);

			if ($(elements[0]).hasClass('md-check') || $(elements[0]).hasClass('md-radiobtn')) {
				if ($(elements[0])[0].checked && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			} else if ($(elements[0]).hasClass('tt-select2')) {
				if (!utils.isUndefined($(elements[0]).select2().val()) && ($(elements[0]).select2().val().length > 1 || ($(elements[0]).select2().val().length === 1 && $(elements[0]).select2().val()[0] !== '')) && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			} else if ($(elements[0]).hasClass('datepicker')) {
				var picker = $(elements[0]).data('picker');
				var dateValue = utils.dateToString(picker.getDate());
				if (dateValue !== '' && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			} else {
				if ($(elements[0]).val() !== '' && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			}

			if (!valid) {
				valid = false;
				var elements = $(element).parents('.tt-content-dialog,.tt-content-detail').find(param[2]);

				var counter = 0;
				jQuery.each(elements, function (i, val) {
					if ($(val).is('.md-check') || $(val).is('.md-radiobtn')) {
						if ($(val)[0].checked) {
							counter++;
						}
					} else if ($(val).is('.tt-select2')) {
						if (!utils.isUndefined($(elements[0]).select2().val()) && ($(val).select2().val().length > 1 || ($(val).select2().val().length === 1 && $(val).select2().val()[0] !== ''))) {
							counter++;
						}
					} else if ($(val).is('.datepicker')) {
						var picker = $(val).data('picker');
						var dateValue = utils.dateToString(picker.getDate());
						if (dateValue !== '') {
							counter++;
						}
					} else {
						if ($(val).val() !== '') {
							counter++;
						}
					}
				});

				if (counter >= param[1]) {
					valid = true;
				}
			}

			return valid;
		},
		Lang.get('extrax2-webadmin.element_from_group_is_required')
	);

	$.validator.addMethod(
		"requiredWhenElementFilled",
		function (value, element, param) {
			var valid = true;

			var elements = $(element).parents('.tt-content-dialog,.tt-content-detail').find(param[0]);

			if ($(elements[0]).hasClass('md-check') || $(elements[0]).hasClass('md-radiobtn')) {
				if ($(elements[0])[0].checked && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			} else if ($(elements[0]).hasClass('tt-select2')) {
				if (!utils.isUndefined($(elements[0]).select2().val()) && ($(elements[0]).select2().val().length > 1 || ($(elements[0]).select2().val().length === 1 && $(elements[0]).select2().val()[0] !== '')) && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			} else if ($(elements[0]).hasClass('datepicker')) {
				var picker = $(val).data('picker');
				var dateValue = utils.dateToString(picker.getDate());
				if (dateValue !== '' && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			} else {
				if ($(elements[0]).val() !== '' && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			}

			return valid;
		},
		'TODO'
	);

	$.validator.addMethod(
		"minLocale",
		function (value, element, param) {
			var valid = true;

			try {
				var number = utils.stringToNumber(value);
				if (number < param) {
					valid = false;
				}

			} catch (NaNError) {
				valid = false;
			}

			return valid;
		},
		Lang.get('extrax2-webadmin.invalid_float')
	);

	$.validator.addMethod(
		"maxLocale",
		function (value, element, param) {
			var valid = true;

			try {
				var number = utils.stringToNumber(value);
				if (number > param) {
					valid = false;
				}

			} catch (NaNError) {
				valid = false;
			}

			return valid;
		},
		Lang.get('extrax2-webadmin.invalid_float')
	);

	$.validator.addMethod(
		"validFloatDecimalPlaces",
		function (value, element, param) {
			var valid = true;

			try {
				var splittedNumber = value.split(utils.getDecimalSeparator());
				if (splittedNumber.length === 2 && utils.stringToNumber(splittedNumber[0]) <= utils.stringToNumber(splittedNumber[1]) + 1) {
					valid = false;
				}

			} catch (NaNError) {
				valid = false;
			}

			return valid;
		},
		Lang.get('extrax2-webadmin.invalid_float')
	);

	$.validator.addMethod(
		"requiredDateFormat",
		function (value, element, param) {

			var selectedValue = $(element).select2().val();

			if (jQuery.inArray('full', selectedValue) !== -1 || jQuery.inArray('mm/yy', selectedValue) !== -1 || jQuery.inArray('yy', selectedValue) !== -1)
			{
				return true;
			}
			return false;
		},
		Lang.get('extrax2-webadmin.element_from_group_is_required')
	);

	$.validator.addMethod(
		'validTime',
		function(value, element, params) {
			if (!utils.isUndefined(value) && value !== '') {

				var showSeconds = true;
				if (!utils.isUndefined($(element).data().showSeconds))
				{
					showSeconds = $(element).data().showSeconds;
				}
				if ((!/^[0-9]*[0-9]:[0-9][0-9]:[0-9][0-9]$/.test(value) && showSeconds) || (!/^[0-9]*[0-9]:[0-9][0-9]$/.test(value) && !showSeconds)) {
					return false;
				}
				var timeArray = value.split(':');
				if (parseInt(timeArray[0]) > 24) {
					return false;
				}
				if (parseInt(timeArray[1]) > 60) {
					return false;
				}
				if (showSeconds) {
					if (parseInt(timeArray[2]) > 60) {
						return false;
					}
				}
			}
			return true;
		},
		Lang.get('extrax2-webadmin.invalid_time')
	);

	$.validator.addMethod(
		'validDate',
		function(value, element, params) {
			if (!utils.isFormatValue(utils.getValueFromInputWithDropDownField($(element))) && value.replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
				var picker = $(element).data('picker');

				return moment(value.replace(/_/g, ''), picker._o.format).isValid();
			}
			return true;
		},
		Lang.get('extrax2-webadmin.invalid_date')
	);

	$.validator.addMethod(
		'validNumber',
		function(value, element, params) {
			try {
				utils.stringToNumber(value);
				return true;
			} catch (NaNError) {
				return false;
			}

		},
		Lang.get('extrax2-webadmin.invalid_number')
	);

	$.validator.addMethod(
		'validIP',
		function(value, element, params) {

			if (value === '') {
				return true;
			}

			var ip = value;
			var endIP = '';
			if (value.indexOf('/') != -1) {
				ip = value.split('/')[0];
				endIP = value.split('/')[1];
			}

			var ipArray = ip.split('.');
			if (ipArray.length != 4) {
				return false;
			}

			if (endIP !== '') {
				try {
					var intEndIP = utils.stringToNumber(endIP);
					if (intEndIP > 999) {
						return false;
					}
				} catch (NaNError) {
					return false;
				}
			}

			var valid = true;
			$.each(ipArray, function(i, value) {
				try {
					var intIP = utils.stringToNumber(value);
					if (intIP > 999) {
						valid = false;
					}
				} catch (NaNError) {
					valid = false;
				}
			});

			return valid;

		},
		Lang.get('extrax2-webadmin.invalid_ip')
	);

	$.validator.addClassRules('datepicker', {
		validDate: true
	});

	$.validator.addClassRules('timepicker', {
		validTime: true
	});

	$.validator.addClassRules('tt-currency', {
		validNumber: true
	});
}

function setValidationToForms(element) {

	$(element).find('.tt-validation-form:not(.validation-container)').each(function () {

		var element = $(this);

		var submitForm = function (form) {

			var validator = this;
			var processData = true;
			var contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
			var action = form.action;

			if (form.id === 'table_licenses_history_item_thresholds_form') {

				setHistoryItemThresholdValues(form);

			} else if (form.id === 'table_licenses_history_item_tokens_form') {

				setHistoryItemTokenValues(form);

			} else if (form.id === 'table_licenses_history_item_default_mask_expressions_form') {

				setHistoryItemDefaultMaskExpressionValues(form);

			} else if (form.id === 'table_contracts_detail_form') {

				closeContract(form);

			} else if (form.id === 'table_calculations_detail_form') {

				closeCalculation(form);

			} else {

				if (form.id === "table_audit_trail_form") {

					App.blockUI({
						target: 'body',
						animate: true
					});

					$('.tt-start-search-audit-trail').addClass('disabled');
					$('.tt-start-search-audit-trail').prop('disabled', 'disabled');

					$('.tt-datatable-search').val('');
					$('#table_audit_trail').dataTable().api().clear().draw();
					$('#table_audit_trail').dataTable().fnFilterClear();

					$('[name="audit_trail_time_stamp"]').val($.now());

				} else if (form.id === "table_participants_add_lanr_bsnr_form") {

					$('#table_participants_add_lanr_bsnr_form').find('[name="charging_by"]').val($('[name="charging_by"]:checked').val());

				} else if (form.id === "table_software_versions_add_document_form" || form.id === "table_software_versions_detail_form") {

					processData = false;
					contentType = false;
				}

				checkContracts(form).done(function (dupilcateBsnrLanr) {

					if (dupilcateBsnrLanr) {

						bootbox.dialog({
							message: Lang.get('extrax2-webadmin.duplicate_bsnr_lanr_desc'),
							title: Lang.get('extrax2-webadmin.duplicate_bsnr_lanr'),
							buttons: {
								yes: {
									label: Lang.get('extrax2-webadmin.ok'),
									className: "btn blue",
									callback: function () {
									}
								}
							}
						});

					} else {

						getFormData(form).done(function (data) {

							var originalData = data;
							var doInitializeElements = false;
							if (utils.GLOBALS.elementToClickAfterSave === null) {
								doInitializeElements = true;
							}

							ajax.ajaxCallExtended(action, form.method, data, false, processData, contentType, null, null, true, null, function (data) {

								if (utils.GLOBALS.elementToClickAfterSave === null || (utils.GLOBALS.elementToClickAfterSave != null && !($(utils.GLOBALS.elementToClickAfterSave).hasClass('tt-create-base-license') || $(utils.GLOBALS.elementToClickAfterSave).hasClass('tt-create-license') || $(utils.GLOBALS.elementToClickAfterSave).hasClass('tt-create-xsd')))) {

									if (!utils.isUndefined($('#send_update_info')) && $('#send_update_info').val() === '1') {

										$(form).removeClass('dirty');
										$(form).trigger('reinitialize.areYouSure');

										$('.tt-send-update-info-mail').click();
									}

									if (form.id.match(/_detail_form$/) || form.id === "table_failed_requests_form") {

										if (form.id === 'table_participants_detail_form' && data === 'MAX_NUMBER_EXCEEDED') {
											bootbox.dialog({
												message: Lang.get('extrax2-webadmin.max_number_participants_exceeded_save'),
												title: Lang.get('extrax2-webadmin.save_participant'),
												buttons: {
													ok: {
														label: Lang.get('extrax2-webadmin.ok'),
														className: "btn blue",
														callback: function () {
														}
													}
												}
											});
										} else {
											showDetailData(data, element, form, validator, doInitializeElements);
										}

									} else if (form.id.match(/_create_form$/)) {

										if (form.id === 'table_participants_create_dialog' && data === 'MAX_NUMBER_EXCEEDED') {
											bootbox.dialog({
												message: Lang.get('extrax2-webadmin.max_number_participants_exceeded_add'),
												title: Lang.get('extrax2-webadmin.add_participant'),
												buttons: {
													ok: {
														label: Lang.get('extrax2-webadmin.ok'),
														className: "btn blue",
														callback: function () {
														}
													}
												}
											});
										} else {
											showNewDetailData(data, element, form, validator, doInitializeElements);
										}

									} else if (form.id === "table_project_partners_form" || form.id === "table_account_settings_form" || form.id === "table_licenses_form") {

										showContentData(data, element, form, validator, doInitializeElements);

									} else if (form.id === "table_users_change_password_form") {

										if (data === '') {
											element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
										} else {
											validator.showErrors({'password': data});
										}

									} else if (form.id === "table_participants_add_lanr_bsnr_form") {

										var newId = addListItem('tab_participant_bsnr_lanr', data, form, false);
										if ($('#tab_participant_bsnr_lanr').find('[name="main_lanr_bsnr_' + newId + '"]').is(':checked')) {
											$('#tab_participant_bsnr_lanr').find('[name="main_lanr_bsnr_' + newId + '"]').trigger('change');
										}

									} else if (form.id === "table_account_settings_add_account_form") {

										addListItem('tab_project_accounting', data, form, true);

									} else if (form.id === "table_account_settings_add_commission_form") {

										addListItem('tab_commission_accounting', data, form, true);

									} else if (form.id === "table_participants_add_account_form") {

										addListItem('tab_participant_account_data', data, form, true);

									} else if (form.id === "table_participants_add_attribute_item_form") {

										addListItem('tab_participant_attribute_items', data, form, false);

									} else if (form.id === "table_project_partners_add_account_form") {

										addListItem('tab_project_partner_account_data', data, form, true);

									} else if (form.id === "table_resellers_add_account_form") {

										addListItem('tab_reseller_account_data', data, form, true);

									} else if (form.id === "table_licenses_add_diagnosis_filter_form") {

										addListItem('licenses_diagnosis_filter_list', data, form, false);

									} else if (form.id === "table_licenses_add_accounting_item_filter_form") {

										addListItem('licenses_accounting_item_filter_list', data, form, false);

									} else if (form.id === "table_licenses_add_history_item_filter_form") {

										addListItem('licenses_history_item_filter_list', data, form, false);

									} else if (form.id === "table_licenses_add_lab_token_form") {

										addListItem('tab_lab_tokens', data, form, false);

									} else if (form.id === "table_licenses_add_default_token_form") {

										addListItem('tab_default_tokens', data, form, false);

									} else if (form.id === "table_licenses_add_free_text_ident_form") {

										addListItem('tab_free_text_idents', data, form, false);

									} else if (form.id === "table_licenses_add_history_item_form") {

										addListItem('tab_history_items', data, form, false);

									} else if (form.id === "table_licenses_history_item_tokens_add_token_form") {

										addListItem('table_licenses_history_item_tokens_form', data, form, false);

									} else if (form.id === "table_licenses_history_item_default_mask_expressions_add_mask_expression_form") {

										addListItem('table_licenses_history_item_default_mask_expressions_form', data, form, false);

									} else if (form.id === "table_licenses_add_attribute_item_form") {

										addListItem('tab_attribute_items', data, form, false);

									} else if (form.id === "table_licenses_add_custom_header_form") {

										addListItem('tab_upload_and_encrypt_data', data, form, false);

									} else if (form.id === "table_resellers_add_license_form") {

										addListItem('tab_reseller_licenses', data, form, true);

									} else if (form.id === "table_software_versions_add_document_form") {

										addListItem('tab_documents', data, form, false);

									} else if (form.id === "table_audit_trail_form") {

										loadAuditTrail(form, data, originalData);

									} else if (form.id === 'table_projects_create_from_license_server_form') {

										$(form).find('.tt-dialog-cancel').click();
										$('#content').find('.tt-content-datatable').find('.tt-datatable').dataTable().fnStandingRedraw();

										bootbox.dialog({
											message: data,
											title: Lang.get('extrax2-webadmin.add_project_from_license_server'),
											buttons: {
												ok: {
													label: Lang.get('extrax2-webadmin.ok'),
													className: "btn blue",
													callback: function () {
													}
												}
											}
										});
									}
								} else {
									$(form).removeClass('dirty');
									$(form).trigger('reinitialize.areYouSure');
								}

								if (utils.GLOBALS.elementToClickAfterSave != null) {
									clickElement(utils.GLOBALS.elementToClickAfterSave, true);
									utils.updateGlobals('elementToClickAfterSave', null);
								}
							});
						});
					}
				});
			}
		}

		var showInformationBox = function (form, validator) {
			var invalids = validator.invalidElements();
			// console.log(invalids);
			if (invalids.length && $(invalids[0]).parents('.tab-pane').length) {
				$(invalids[0]).parents('.tabbable-line').find('.tab-pane').removeClass('active');
				$(invalids[0]).parents('.tabbable-line').find('.nav-tabs li').removeClass('active');
				$(invalids[0]).parents('.tab-pane').addClass('active');
				$('[href="#' + $(invalids[0]).parents('.tab-pane')[0].id + '"]').parent().addClass('active');
			}
			$(form.target).parents('.tt-content-detail').find('.tt-save').removeClass('disabled');
			$(form.target).parents('.tt-content-detail').find('.tt-save').removeAttr('disabled');
			showValidationMessage();
		}

		$(this).validate({

			debug: false,

			errorElement: 'span', //default input error message container

			errorClass: 'help-block help-block-error', // default input error message class

			focusInvalid: false, // do not focus the last invalid input

			ignore: getIgnore(element),

			rules: getRules(element),

			messages: getMessages(element),

			submitHandler: submitForm,

			invalidHandler: showInformationBox,

			errorPlacement: function (error, element) {
				if (element.is(':checkbox')) {
					error.insertAfter(element.closest(".md-checkbox, .md-checkbox-list, .md-checkbox-inline, .checkbox-list, .checkbox-inline"));
				} else if (element.is(':radio')) {
					error.insertAfter(element.closest(".md-radio-list, .md-radio-inline, .radio-list,.radio-inline"));
				} else {
					element.parent().append(error);
				}
			},

			highlight: function (element, errorClass, validClass) {
				$(element).closest('.form-group').addClass('has-error'); // set error class to the control group
			},

			unhighlight: function (element, errorClass, validClass) {
				$(element).closest('.form-group').removeClass('has-error'); // set error class to the control group
			}
		});

		addListRules(this);

		$(this).addClass("validation-container");
	});
}

function clickElement(el) {

	return $.Deferred(function (defer) {
		utils.updateGlobals('programmaticClick', true);
		el.click();
		utils.updateGlobals('programmaticClick', false);
		defer.resolve();

	}).promise();
}

function getFormData(form) {

	return $.Deferred(function (defer) {
		var data = utils.getSerializedFormData(form);
		data = addSummernoteData(data);

		if (form.id === "table_software_versions_add_document_form" || form.id === "table_software_versions_detail_form") {
			data = new FormData(form);
			defer.resolve(data);
		} else {
			defer.resolve(data);
		}

	}).promise();
}

function showValidationMessage() {

	toastr.options = {
		"closeButton": false,
		"debug": false,
		"positionClass": "toast-top-right",
		"onclick": null,
		"showDuration": "1000",
		"hideDuration": "1000",
		"timeOut": "5000",
		"extendedTimeOut": "1000",
		"showEasing": "swing",
		"hideEasing": "linear",
		"showMethod": "fadeIn",
		"hideMethod": "fadeOut"
	}

	toastr.error(trans('extrax2-webadmin.validation_message'), trans('extrax2-webadmin.validation'));
}

function getRules(element) {

	var rules = {};

	if (element[0].id === "table_users_detail_form" || element[0].id === "table_users_create_form") {
		rules = {
			username: {
				required: true,
				validUsername: true,
				customMethod: true
			},
			firstname: {
				required: true
			},
			name: {
				required: true
			},
			email: {
				required: true,
				email: true
			},
			password_lifetime: {
				required: true,
				digits: true,
				min: 0
			},
			password: {
				required: true,
				minlength: 8,
				minNonAlpha: 2
			},
			password_repetition: {
				equalTo: '#m_password'
			}
		};
	} else if (element[0].id === "table_users_change_password_form") {
		rules = {
			password: {
				required: true,
				minlength: 8,
				minNonAlpha: 2
			},
			password_repetition: {
				equalTo: '#m_password'
			}
		};
	} else if (element[0].id === "table_projects_detail_form" || element[0].id === "table_projects_create_form" || element[0].id === "table_projects_create_from_license_server_form") {
		rules = {
			projectname: {
				required: true,
				customMethod: true
			},
			abbreviation: {
				required: true,
				customMethod: true
			},
			max_number_of_participants: {
				digits: true,
				min: 1
			},
			ip_limitation: {
				validIP: true
			}
		};
	} else if (element[0].id === "table_project_partners_form") {
		rules = {
			email: {
				email: true
			},
			email_contact1: {
				email: true
			},
			email_contact2: {
				email: true
			},
			iban: {
				customMethod: true
			}
		};
	} else if (element[0].id === "table_participants_detail_form" || element[0].id === "table_participants_create_form") {
		rules = {
			medical_practice_name: {
				required: true
			},
			street: {
				required: true
			},
			streetnumber: {
				required: true
			},
			postal_code: {
				maxlength: 5,
				minlength: 5,
				digits: true,
				required: true
			},
			city: {
				required: true
			},
			phone: {
				required: true
			},
			pvs_id: {
				required: true
			},
			email: {
				required: true,
				email: true
			},
			email_technical_support: {
				email: true
			},
			email_invoice: {
				email: true
			},
			iban: {
				customMethod: true
			},
			iban_invoice: {
				customMethod: true
			},
			identificationnumber: {
				required: true
			},
			license_owner: {
				required: true
			},
			facility: {
				required: true,
				customMethod: true
			},
			export_date_from: {
				required: true
			},
			pvs_license: {
				required: true
			},
			first_letter_patient: {
				maxlength: 1
			},
			max_patient_number: {
				digits: true,
				min: 1
			},
			serial_number: {
				validSerialNumber: true
			},
			contract_start_date: {
				required: true
			},
			check_for_main_lanr_bsnr: {
				checkForMainLanrBsnr: true
			},
			check_for_main_bsnr: {
				checkForMainBsnr: true
			}
		};

		if (!utils.isUndefined($(element).find('[name="export_date_from"]').data()) && $(element).find('[name="export_date_from"]').data().minValue.length) {
			rules_export_date_from = {
				export_date_from: {
					required: true,
					minDate: utils.dateToLocaleString(utils.stringToDate($('[name="export_date_from"]').data().minValue))
				}
			}
			$.extend(rules, rules_export_date_from);
		}

		var foundRecipientParticipant = false;
		var foundRecipientParticipantInvoice = false;
		jQuery.each($('[name^="invoice_recipient_"]'), function (i, element) {
			if ($(element).val() === 'participant') {
				foundRecipientParticipant = true;
			}
			if ($(element).val() === 'participant_invoice') {
				foundRecipientParticipantInvoice = true;
			}
		});
		if (foundRecipientParticipant) {
			rules_recipient_participant = {
				iban: {
					customMethod: true
				}
			}
			$.extend(rules, rules_recipient_participant);
		}
		if (foundRecipientParticipantInvoice) {
			rules_recipient_participant_invoice = {
				address1_invoice: {
					required: true
				},
				address2_invoice: {
					required: true
				},
				street_invoice: {
					required: true
				},
				streetnumber_invoice: {
					required: true
				},
				postal_code_invoice: {
					maxlength: 5,
					minlength: 5,
					digits: true,
					required: true
				},
				city_invoice: {
					required: true
				},
				phone_invoice: {
					required: true
				},
				iban_invoice: {
					required: true,
					customMethod: true
				},
				email_invoice: {
					required: true,
					email: true
				},
				accountholder_invoice: {
					required: true
				}
			}
			$.extend(rules, rules_recipient_participant_invoice);
		}
	} else if (element[0].id === "table_participants_add_lanr_bsnr_form") {
		rules = {
			bsnr: {
				requiredWhenElementFilled: ['[name="doctor_name"]'],
				maxlength: 9,
				validBsnrLanr: true,
				minOneFullBsnrOrLanr: true
			},
			lanr: {
				requiredWhenElementFilled: ['[name="doctor_name"]'],
				maxlength: 9,
				validBsnrLanr: true,
				minOneFullBsnrOrLanr: true
			},
			doctor_name: {
				requireFromGroup: [1, '.tt-lanr-bsnr-group']
			},
			assign_contract_from: {
				requireFromGroup: [1, '.tt-lanr-bsnr-group']
			}
		};
	} else if (element[0].id === "table_participants_add_attribute_item_form" || element[0].id === "table_licenses_add_attribute_item_form") {
		rules = {
			key: {
				required: true
			}
		};
	} else if (element[0].id === "table_contracts_detail_form") {
		rules = {
			invoice_recipient: {
				required: true
			},
			voucher_code: {
				customMethod: true
			},
			minimum_duration: {
				digits: true
			},
			duration: {
				digits: true
			},
			accounting_period: {
				digits: true
			},
			notice: {
				digits: true
			}
		};
	} else if (element[0].id === "table_commission_recipients_detail_form" || element[0].id === "table_commission_recipients_create_form") {
		rules = {
			address1: {
				required: true
			},
			email: {
				email: true
			}
		};
	} else if (element[0].id === "table_resellers_detail_form" || element[0].id === "table_resellers_create_form") {
		rules = {
			address1: {
				required: true
			},
			email: {
				email: true
			},
			iban: {
				customMethod: true
			}
		};
	} else if (element[0].id === "table_resellers_add_license_form") {
		rules = {
			contract_date: {
				required: true
			},
			licenses: {
				required: true,
				digits: true,
				min: 1
			},
			amount_per_license: {
				required: true
			}
		};
	} else if (element[0].id === "table_account_settings_form") {
		rules = {
			minimum_duration: {
				digits: true
			},
			minimum_payment_lanr: {
				digits: true
			},
			minimum_payment_bsnr: {
				digits: true
			},
			minimum_payment_account_id: {
				digits: true
			},
			duration: {
				digits: true
			},
			accounting_period: {
				digits: true
			},
			notice: {
				digits: true
			}
		};
	} else if (element[0].id === "table_account_settings_add_account_form" || element[0].id === "table_participants_add_account_form" || element[0].id === "table_project_partners_add_account_form" || element[0].id === "table_resellers_add_account_form") {
		rules = {
			lanr_bsnr: {
				required: true
			},
			from_number_of_lanr_bsnr: {
				digits: true
			},
			amount_per_period_and_participant: {
				required: true
			},
			once_only_amount: {
				required: true
			},
			valid_from: {
				required: true
			}
		};
	} else if (element[0].id === "table_account_settings_add_commission_form") {
		rules = {
			commission_rate: {
				required: true
			},
			once_only_commission: {
				requireFromGroup: [1, '.tt-commission-group']
			},
			repetitive_commission: {
				requireFromGroup: [1, '.tt-commission-group']
			},
			repetitive_commission_time_unit: {
				digits: true
			},
			valid_from_commission: {
				required: true
			}
		};

		if ($(element).find('[name="repetitive_commission"]').val().length) {
			rules_repetitive_commission_time_unit = {
				repetitive_commission_time_unit: {
					required: true
				}
			}
			$.extend(rules, rules_repetitive_commission_time_unit);
		}
	} else if (element[0].id === "table_licenses_form") {
		rules = {
			license_server_url: {
				// url: true
			},
			private_public_key_authentication: {
				customMethod: true
			},
			grace_period: {
				digits: true
			},
			check_period: {
				digits: true
			},
			default_range: {
				digits: true,
				min: 1
			},
			initial_range: {
				digits: true,
				min: 1
			},
			cut_off_day: {
				digits: true
			},
			cut_off_day_vacation_mode: {
				digits: true
			},
			initial_export_chunk_size: {
				digits: true
			},
			export_chunk_size: {
				digits: true
			},
			export_bsnr_hash_salt: {
				requiredWhenElementFilled: ['[name="export_bsnr_hash"]']
			},
			export_lanr_hash_salt: {
				requiredWhenElementFilled: ['[name="export_lanr_hash"]']
			},
			export_user_hash_salt: {
				requiredWhenElementFilled: ['[name="export_user_hash"]']
			},
			activation_hotline_email: {
				email: true
			},
			support_hotline_email: {
				email: true
			},
			activation_period_of_validity: {
				digits: true,
				min: 1
			},
			upload_port: {
				digits: true,
				min: 1
			},
			encrypt_key_index: {
				digits: true
			},
			encrypt_magic_word: {
				maxlength: 4,
				minlength: 4
			},
			threshold_failed_patients_min_for_error: {
				digits: true,
				min: 1
			},
			threshold_failed_patients_min_for_warning: {
				digits: true,
				min: 1
			},
			threshold_failed_card_entries_min_for_error: {
				digits: true,
				min: 1
			},
			threshold_failed_card_entries_min_for_warning: {
				digits: true,
				min: 1
			},
			threshold_incomplete_patients_min_for_error: {
				digits: true,
				min: 1
			},
			threshold_incomplete_patients_min_for_warning: {
				digits: true,
				min: 1
			},
			threshold_failed_patients_rel_min_for_error: {
				digits: true,
				min: 1,
				max: 100
			},
			threshold_failed_patients_rel_min_for_warning: {
				digits: true,
				min: 1,
				max: 100
			},
			threshold_failed_card_entries_rel_min_for_error: {
				digits: true,
				min: 1,
				max: 100
			},
			threshold_failed_card_entries_rel_min_for_warning: {
				digits: true,
				min: 1,
				max: 100
			},
			threshold_incomplete_patients_rel_min_for_error: {
				digits: true,
				min: 1,
				max: 100
			},
			threshold_incomplete_patients_rel_min_for_warning: {
				digits: true,
				min: 1,
				max: 100
			}
		};
	} else if (element[0].id === "table_licenses_add_diagnosis_filter_form") {
		rules = {
			icd: {
				required: true
			}
		};
	} else if (element[0].id === "table_licenses_add_accounting_item_filter_form") {
		rules = {
			accounting_item: {
				required: true
			},
			accounting_item_type: {
				required: true
			}
		};
	} else if (element[0].id === "table_licenses_add_history_item_filter_form") {
		rules = {
			history_item: {
				required: true
			}
		};
	} else if (element[0].id === "table_licenses_add_lab_token_form") {
		rules = {
			lab_token: {
				required: true
			}
		};
	} else if (element[0].id === "table_licenses_add_default_token_form") {
		rules = {
			pvs_id: {
				required: true
			},
			ident: {
				required: true
			},
			token: {
				required: true
			}
		};
	} else if (element[0].id === "table_licenses_add_free_text_ident_form") {
		rules = {
			pvs_id: {
				required: true
			},
			ident: {
				required: true
			}
		};
	} else if (element[0].id === "table_licenses_add_history_item_form") {
		rules = {
			item: {
				required: true
			},
			description: {
				required: true
			}
		};
	} else if (element[0].id === "table_licenses_add_custom_header_form") {
		rules = {
			custom_header: {
				required: true
			},
			custom_header_value: {
				required: true
			}
		};
	} else if (element[0].id === "table_licenses_history_item_thresholds_form") {
		rules = {
			threshold_hits_min_for_warning: {
				digits: true,
				min: 1
			},
			threshold_hits_min_for_error: {
				digits: true,
				min: 1
			},
			threshold_patients_with_hits_min_for_warning: {
				digits: true,
				min: 1
			},
			threshold_patients_with_hits_min_for_error: {
				digits: true,
				min: 1
			},
			threshold_hits_rel_min_for_warning: {
				digits: true,
				min: 1,
				max: 100
			},
			threshold_hits_rel_min_for_error: {
				digits: true,
				min: 1,
				max: 100
			},
			threshold_patients_with_hits_rel_min_for_warning: {
				digits: true,
				min: 1,
				max: 100
			},
			threshold_patients_with_hits_rel_min_for_error: {
				digits: true,
				min: 1,
				max: 100
			}
		};
	} else if (element[0].id === "table_licenses_history_item_tokens_add_token_form") {
		rules = {
			token: {
				required: true
			}
		};
	} else if (element[0].id === "table_licenses_history_item_default_mask_expressions_add_mask_expression_form") {
		rules = {
			mask_expression_pvs_id: {
				required: true
			},
			mask_expression_ident: {
				required: true
			},
			mask_expression_expression: {
				required: true
			}
		};
	} else if (element[0].id === "table_calculations_detail_form") {
		rules = {
			pvs_usage: {
				required: true
			},
			extraction_rate: {
				required: true
			},
			extraction_retrospective: {
				required: true
			},
			limited_use: {
				required: true
			},
			master_data: {
				requireFromGroup: [1, '.tt-data-category']
			},
			insurance_data: {
				requireFromGroup: [1, '.tt-data-category']
			},
			clinical_master_data: {
				requireFromGroup: [1, '.tt-data-category']
			},
			insurance_certificate: {
				requireFromGroup: [1, '.tt-data-category']
			},
			private_certificate: {
				requireFromGroup: [1, '.tt-data-category']
			},
			misc_certificate: {
				requireFromGroup: [1, '.tt-data-category']
			},
			form_data: {
				requireFromGroup: [1, '.tt-data-category']
			},
			medication_plan: {
				requireFromGroup: [1, '.tt-data-category']
			},
			medication_mapper: {
				requireFromGroup: [1, '.tt-data-category']
			},
			lab_data: {
				requireFromGroup: [1, '.tt-data-category']
			},
			clinical_course_data: {
				requireFromGroup: [1, '.tt-data-category']
			},
			misc_data: {
				requireFromGroup: [1, '.tt-data-category']
			},
			invoices: {
				requireFromGroup: [1, '.tt-data-category']
			},
			invoices_insurance_association: {
				requireFromGroup: [1, '.tt-data-category']
			},
			ims_data: {
				requireFromGroup: [1, '.tt-data-category']
			},
			medication: {
				requireFromGroup: [1, '.tt-data-category']
			},
			permanent_diagnosis: {
				requireFromGroup: [1, '.tt-data-category']
			},
			diagnosis: {
				requireFromGroup: [1, '.tt-data-category']
			},
			prescription_medication: {
				requireFromGroup: [1, '.tt-data-category']
			},
			prescription_adjuvant: {
				requireFromGroup: [1, '.tt-data-category']
			},
			prescription_remedies: {
				requireFromGroup: [1, '.tt-data-category']
			},
			permanent_medication: {
				requireFromGroup: [1, '.tt-data-category']
			}
		};
	} else if (element[0].id === "table_failed_requests_form") {
		rules = {
			support_id: {
				required: true,
				customMethod: true
			}
		};
	} else if (element[0].id === "table_reminders_detail_form" || element[0].id === "table_reminders_create_form") {
		rules = {
			reminder_type: {
				required: true
			},
			internal_or_external: {
				required: true
			},
			subject: {
				required: true
			},
			internal_recipient: {
				email: true,
				requireFromGroup: [1, '.validation-group-internal-recipient']
			},
			user_id: {
				requireFromGroup: [1, '.validation-group-internal-recipient']
			},
			external_recipient: {
				email: true,
				requireFromGroupWhenElementFilled: ['[name="internal_or_external"][value="external"]', 1, '.validation-group-external-recipient']
			},
			external_recipient_is_participant: {
				requireFromGroupWhenElementFilled: ['[name="internal_or_external"][value="external"]', 1, '.validation-group-external-recipient']
			},
			email_address_sender: {
				email: true
			},
			schedule_type: {
				required: true
			},
			schedule_time: {
				required: true
			},
			selection_months: {
				requiredWhenElementFilled: ['[name="schedule_type"][value="monthly"]']
			},
			repeat_monthly_on_day: {
				requireFromGroupWhenElementFilled: ['[name="schedule_type"][value="monthly"]', 1, '.validation-group-schedule-type-monthly']
			},
			repeat_monthly: {
				requireFromGroupWhenElementFilled: ['[name="schedule_type"][value="monthly"]', 1, '.validation-group-schedule-type-monthly'],
				requiredWhenElementFilled: ['[name="repeat_monthly_on_day_of_the_week"]']
			},
			repeat_monthly_on_day_of_the_week: {
				requiredWhenElementFilled: ['[name="repeat_monthly"]']
			},
			repeat_all_x_weeks: {
				min: 1,
				digits: true,
				requiredWhenElementFilled: ['[name="schedule_type"][value="weekly"]']
			},
			selection_days: {
				requiredWhenElementFilled: ['[name="schedule_type"][value="weekly"]']
			},
			repeat_all_x_days: {
				min: 1,
				digits: true,
				requiredWhenElementFilled: ['[name="schedule_type"][value="daily"]']
			},
			additional_interval_days: {
				min: 1,
				digits: true
			}

		};
	} else if (element[0].id === "table_settings_form") {
		rules = {
			ip_exclusion: {
				validIP: true
			}

		};
	} else if (element[0].id === "table_audit_trail_form") {
		rules = {
			audit_trail_tables_to_search: {
				requireFromGroup: [1, '.search-group']
			},
			audit_trail_projects: {
				requireFromGroup: [1, '.search-group']
			},
			audit_trail_users: {
				requireFromGroup: [1, '.search-group']
			},
			audit_trail_participants: {
				requireFromGroup: [1, '.search-group']
			}
		};
	} else if (element[0].id === "table_email_recipients_form" || element[0].id === "table_email_recipients_create_form") {
		rules = {
			email: {
				requireFromGroup: [1, '.search-group'],
				email: true
			},
			active_participants: {
				requireFromGroup: [1, '.search-group']
			},
			user_id: {
				requireFromGroup: [1, '.search-group']
			},
			project_partner_id: {
				requireFromGroup: [1, '.search-group']
			},
			project_partner_contact1: {
				requireFromGroup: [1, '.search-group']
			},
			project_partner_contact2: {
				requireFromGroup: [1, '.search-group']
			}
		};
	} else if(element[0].id === "table_software_versions_add_document_form") {
		rules = {
			category: {
				required: true
			},
			file_description: {
				required: true
			},
			file_name: {
				required: true
			}
		};
	}

	return rules;
}

function addListRules(element) {

	$(element).find('[name^="lanr_"]:not([name^="lanr_bsnr_"],[name="lanr_bsnr"],[name="lanr_validation"])').each(function() {
		$(this).rules('add', {
			required: true,
			maxlength: 9,
			validBsnrLanr: true,
			minOneFullBsnrOrLanr: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_lanr'),
				maxlength: Lang.get('extrax2-webadmin.invalid_lanr'),
				validBsnrLanr: Lang.get('extrax2-webadmin.invalid_lanr')
			}
		});
	});

	$(element).find('[name^="bsnr_"]:not([name="bsnr_validation"])').each(function() {
		$(this).rules('add', {
			required: true,
			maxlength: 9,
			validBsnrLanr: true,
			minOneFullBsnrOrLanr: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_bsnr'),
				maxlength: Lang.get('extrax2-webadmin.invalid_bsnr'),
				validBsnrLanr: Lang.get('extrax2-webadmin.invalid_bsnr')
			}
		});
	});

	$(element).find('[name^="lanr_bsnr_account_id_"]:not([type="hidden"])').each(function() {
		$(this).rules('add', {
			requiredWhenElementFilled: ['[name="charging_by"][value="account_id"]'],
			messages: {
				requiredWhenElementFilled: Lang.get('extrax2-webadmin.required_account_id')
			}
		});
	});

	$(element).find('[name^="doctor_name_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_doctor_name')
			}
		});
	});

	$(element).find('[name^="lanr_bsnr_"]:not([name^="lanr_bsnr_account_id"])').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_lanr_bsnr')
			}
		});
	});

	$(element).find('[name^="from_number_of_lanr_bsnr_"]').each(function() {
		$(this).rules('add', {
			digits: true,
			messages: {
				digits: Lang.get('extrax2-webadmin.positiv_integer')
			}
		});
	});

	$(element).find('[name^="amount_per_period_and_participant_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_amount_per_period_and_participant')
			}
		});
	});

	$(element).find('[name^="once_only_amount_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_once_only_amount')
			}
		});
	});

	$(element).find('[name^="valid_from_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_valid_from')
			}
		});
	});

	$(element).find('[name^="commission_rate_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_commission_rate')
			}
		});
	});

	$(element).find('[name^="repetitive_commission_time_unit_"]').each(function() {
		$(this).rules('add', {
			digits: true,
			messages: {
				digits: Lang.get('extrax2-webadmin.positiv_integer')
			}
		});
	});

	$(element).find('[name^="once_only_commission_"],[name^="repetitive_commission_"]:not([name^="repetitive_commission_time_unit"])').each(function() {
		var id = $(this)[0].name.substring($(this)[0].name.lastIndexOf('_') + 1);
		$(this).rules('add', {
			requireFromGroup: [1, '.tt-commission-group-' + id]
		});
	});

	$(element).find('[name^="pvs_id_"],[name^="mask_expression_pvs_id_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_pvs')
			}
		});
	});

	$(element).find('[name^="ident_"],[name^="mask_expression_ident_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_ident')
			}
		});
	});

	$(element).find('[name^="token_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_token')
			}
		});
	});

	$(element).find('[name^="item_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_item')
			}
		});
	});

	$(element).find('[name^="description_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_description')
			}
		});
	});

	$(element).find('[name^="key_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_key')
			}
		});
	});

	$(element).find('[name^="value_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_value')
			}
		});
	});

	$(element).find('[name^="mask_expression_expression_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_expression')
			}
		});
	});

	$(element).find('[name^="licenses_"]:not([name="licenses_cancel_export"])').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_licenses')
			}
		});
		$(this).rules('add', {
			digits: true,
			messages: {
				digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
			}
		});
		$(this).rules('add', {
			min: 1,
			messages: {
				min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
			}
		});
	});

	$(element).find('[name^="amount_per_license_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_amount_per_license')
			}
		});
	});

	$(element).find('[name^="category_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_category')
			}
		});
	});

	$(element).find('[name^="file_description_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_file_description')
			}
		});
	});

	$(element).find('[name^="file_name_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_file_name')
			}
		});
	});

	$(element).find('[name^="custom_header_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_custom_header')
			}
		});
	});

	$(element).find('[name^="custom_header_value_"]').each(function() {
		$(this).rules('add', {
			required: true,
			messages: {
				required: Lang.get('extrax2-webadmin.required_custom_header_value')
			}
		});
	});

}

function getMessages(element) {

	var messages = '';
	messages = {
		username: {
			required: Lang.get('extrax2-webadmin.required_username'),
			remote: Lang.get('extrax2-webadmin.username_exists'),
			customMethod: Lang.get('extrax2-webadmin.username_exists')
		},
		firstname: {
			required: Lang.get('extrax2-webadmin.required_firstname')
		},
		name: {
			required: Lang.get('extrax2-webadmin.required_name')
		},
		email: {
			required: Lang.get('extrax2-webadmin.required_email'),
			email: Lang.get('extrax2-webadmin.invalid_email')
		},
		email_technical_support: {
			required: Lang.get('extrax2-webadmin.required_email'),
			email: Lang.get('extrax2-webadmin.invalid_email')
		},
		email_invoice: {
			required: Lang.get('extrax2-webadmin.required_email'),
			email: Lang.get('extrax2-webadmin.invalid_email')
		},
		email_contact1: {
			email: Lang.get('extrax2-webadmin.invalid_email')
		},
		email_contact2: {
			email: Lang.get('extrax2-webadmin.invalid_email')
		},
		password_lifetime: {
			required: Lang.get('extrax2-webadmin.required_password_lifetime'),
			digits: Lang.get('extrax2-webadmin.positiv_integer'),
			min: Lang.get('extrax2-webadmin.positiv_integer')
		},
		password: {
			required: Lang.get('extrax2-webadmin.required_password'),
			minlength: Lang.get('extrax2-webadmin.field_length', { "attribute": Lang.get('extrax2-webadmin.password'), "min": "{0}" })
		},
		password_repetition: {
			equalTo: Lang.get('extrax2-webadmin.wrong_password_repetition')
		},
		street: {
			required: Lang.get('extrax2-webadmin.required_street')
		},
		street_invoice: {
			required: Lang.get('extrax2-webadmin.required_street')
		},
		streetnumber: {
			required: Lang.get('extrax2-webadmin.required_streetnumber')
		},
		streetnumber_invoice: {
			required: Lang.get('extrax2-webadmin.required_streetnumber')
		},
		postal_code: {
			required: Lang.get('extrax2-webadmin.required_postal_code'),
			maxlength: Lang.get('extrax2-webadmin.invalid_postal_code'),
			minlength: Lang.get('extrax2-webadmin.invalid_postal_code'),
			digits: Lang.get('extrax2-webadmin.invalid_postal_code')
		},
		postal_code_invoice: {
			required: Lang.get('extrax2-webadmin.required_postal_code'),
			maxlength: Lang.get('extrax2-webadmin.invalid_postal_code'),
			minlength: Lang.get('extrax2-webadmin.invalid_postal_code'),
			digits: Lang.get('extrax2-webadmin.invalid_postal_code')
		},
		city: {
			required: Lang.get('extrax2-webadmin.required_city')
		},
		city_invoice: {
			required: Lang.get('extrax2-webadmin.required_city')
		},
		phone: {
			required: Lang.get('extrax2-webadmin.required_phone')
		},
		phone_invoice: {
			required: Lang.get('extrax2-webadmin.required_phone')
		},
		pvs_id: {
			required: Lang.get('extrax2-webadmin.required_pvs')
		},
		pvs_license: {
			required: Lang.get('extrax2-webadmin.required_pvs')
		},
		contract_start_date: {
			required: Lang.get('extrax2-webadmin.required_contract_start_date')
		},
		identificationnumber: {
			required: Lang.get('extrax2-webadmin.required_identificationnumber')
		},
		license_owner: {
			required: Lang.get('extrax2-webadmin.required_license_owner')
		},
		facility: {
			required: Lang.get('extrax2-webadmin.required_license_facility'),
			customMethod: Lang.get('extrax2-webadmin.invalid_facility')
		},
		export_date_from: {
			required: Lang.get('extrax2-webadmin.required_export_date_from'),
			minDate: Lang.get('extrax2-webadmin.date_below_min_date', {"min": "{0}"})
		},
		projectname: {
			required: Lang.get('extrax2-webadmin.required_projectname'),
			remote: Lang.get('extrax2-webadmin.projectname_exists'),
			customMethod: Lang.get('extrax2-webadmin.projectname_exists')
		},
		abbreviation: {
			required: Lang.get('extrax2-webadmin.required_abbreviation'),
			remote: Lang.get('extrax2-webadmin.abbreviation_exists'),
			customMethod: Lang.get('extrax2-webadmin.abbreviation_exists')
		},
		iban: {
			required: Lang.get('extrax2-webadmin.required_iban'),
			remote: Lang.get('extrax2-webadmin.invalid_iban'),
			customMethod: Lang.get('extrax2-webadmin.invalid_iban')
		},
		iban_invoice: {
			required: Lang.get('extrax2-webadmin.required_iban'),
			remote: Lang.get('extrax2-webadmin.invalid_iban'),
			customMethod: Lang.get('extrax2-webadmin.invalid_iban')
		},
		accountholder: {
			required: Lang.get('extrax2-webadmin.required_accountholder')
		},
		accountholder_invoice: {
			required: Lang.get('extrax2-webadmin.required_accountholder')
		},
		max_patient_number: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		max_number_of_participants: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		first_letter_patient: {
			maxlength: Lang.get('extrax2-webadmin.first_letter_max_length')
		},
		medical_practice_name: {
			required: Lang.get('extrax2-webadmin.required_medical_practice_name')
		},
		bsnr: {
			requiredWhenElementFilled: Lang.get('extrax2-webadmin.required_bsnr'),
			maxlength: Lang.get('extrax2-webadmin.invalid_bsnr'),
			validBsnrLanr: Lang.get('extrax2-webadmin.invalid_bsnr')
		},
		lanr: {
			requiredWhenElementFilled: Lang.get('extrax2-webadmin.required_lanr'),
			maxlength: Lang.get('extrax2-webadmin.invalid_lanr'),
			validBsnrLanr: Lang.get('extrax2-webadmin.invalid_lanr')
		},
		doctor_name: {
			required: Lang.get('extrax2-webadmin.required_doctor_name')
		},
		invoice_recipient: {
			required: Lang.get('extrax2-webadmin.required_invoice_recipient')
		},
		address1: {
			required: Lang.get('extrax2-webadmin.required_address1')
		},
		address1_invoice: {
			required: Lang.get('extrax2-webadmin.required_address1')
		},
		address2_invoice: {
			required: Lang.get('extrax2-webadmin.required_address2')
		},
		minimum_duration: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		minimum_payment_bsnr: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		minimum_payment_lanr: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		minimum_payment_account_id: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		duration: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		accounting_period: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		notice: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		lanr_bsnr: {
			required: Lang.get('extrax2-webadmin.required_lanr_bsnr')
		},
		from_number_of_lanr_bsnr: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		amount_per_period_and_participant: {
			required: Lang.get('extrax2-webadmin.required_amount_per_period_and_participant')
		},
		once_only_amount: {
			required: Lang.get('extrax2-webadmin.required_once_only_amount')
		},
		valid_from: {
			required: Lang.get('extrax2-webadmin.required_valid_from')
		},
		commission_rate: {
			required: Lang.get('extrax2-webadmin.required_commission_rate')
		},
		repetitive_commission_time_unit: {
			digits: Lang.get('extrax2-webadmin.positiv_integer'),
			required: Lang.get('extrax2-webadmin.required_repetitive_commission_time_unit')
		},
		license_server_url: {
			url: Lang.get('extrax2-webadmin.invalid_url')
		},
		private_public_key_authentication: {
			remote: Lang.get('extrax2-webadmin.public_key_missing'),
			customMethod: Lang.get('extrax2-webadmin.public_key_missing')
		},
		grace_period: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		check_period: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		default_range: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		initial_range: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		cut_off_day: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		cut_off_day_vacation_mode: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		initial_export_chunk_size: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		export_chunk_size: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		activation_period_of_validity: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		activation_hotline_email: {
			email: Lang.get('extrax2-webadmin.invalid_email')
		},
		support_hotline_email: {
			email: Lang.get('extrax2-webadmin.invalid_email')
		},
		upload_port: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		encrypt_key_index: {
			digits: Lang.get('extrax2-webadmin.positiv_integer')
		},
		encrypt_magic_word: {
			maxlength: Lang.get('extrax2-webadmin.encrypt_magic_word_max_length'),
			minlength: Lang.get('extrax2-webadmin.encrypt_magic_word_max_length')
		},
		threshold_failed_patients_min_for_error: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		threshold_failed_patients_min_for_warning: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		threshold_failed_card_entries_min_for_error: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		threshold_failed_card_entries_min_for_warning: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		threshold_incomplete_patients_min_for_error: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		threshold_incomplete_patients_min_for_warning: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		threshold_failed_patients_rel_min_for_error: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			min: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			max: Lang.get('extrax2-webadmin.positiv_integer_percentage')
		},
		threshold_failed_patients_rel_min_for_warning: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			min: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			max: Lang.get('extrax2-webadmin.positiv_integer_percentage')
		},
		threshold_failed_card_entries_rel_min_for_error: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			min: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			max: Lang.get('extrax2-webadmin.positiv_integer_percentage')
		},
		threshold_failed_card_entries_rel_min_for_warning: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			min: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			max: Lang.get('extrax2-webadmin.positiv_integer_percentage')
		},
		threshold_incomplete_patients_rel_min_for_error: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			min: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			max: Lang.get('extrax2-webadmin.positiv_integer_percentage')
		},
		threshold_incomplete_patients_rel_min_for_warning: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			min: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			max: Lang.get('extrax2-webadmin.positiv_integer_percentage')
		},
		icd: {
			required: Lang.get('extrax2-webadmin.required_diagnosis')
		},
		accounting_item: {
			required: Lang.get('extrax2-webadmin.required_accounting_item')
		},
		accounting_item_type: {
			required: Lang.get('extrax2-webadmin.required_accounting_item_type')
		},
		lab_token: {
			required: Lang.get('extrax2-webadmin.required_lab_token')
		},
		token: {
			required: Lang.get('extrax2-webadmin.required_token')
		},
		ident: {
			required: Lang.get('extrax2-webadmin.required_ident')
		},
		pvs_id: {
			required: Lang.get('extrax2-webadmin.required_pvs')
		},
		item: {
			required: Lang.get('extrax2-webadmin.required_item')
		},
		description: {
			required: Lang.get('extrax2-webadmin.required_description')
		},
		threshold_hits_min_for_warning: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		threshold_hits_min_for_error: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		threshold_patients_with_hits_min_for_warning: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		threshold_patients_with_hits_min_for_error: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		threshold_hits_rel_min_for_warning: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			min: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			max: Lang.get('extrax2-webadmin.positiv_integer_percentage')
		},
		threshold_hits_rel_min_for_error: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			min: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			max: Lang.get('extrax2-webadmin.positiv_integer_percentage')
		},
		threshold_patients_with_hits_rel_min_for_warning: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			min: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			max: Lang.get('extrax2-webadmin.positiv_integer_percentage')
		},
		threshold_patients_with_hits_rel_min_for_error: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			min: Lang.get('extrax2-webadmin.positiv_integer_percentage'),
			max: Lang.get('extrax2-webadmin.positiv_integer_percentage')
		},
		mask_expression_pvs_id: {
			required: Lang.get('extrax2-webadmin.required_pvs')
		},
		mask_expression_ident: {
			required: Lang.get('extrax2-webadmin.required_token')
		},
		mask_expression_expression: {
			required: Lang.get('extrax2-webadmin.required_expression')
		},
		contract_date: {
			required: Lang.get('extrax2-webadmin.required_contract_date')
		},
		licenses: {
			required: Lang.get('extrax2-webadmin.required_licenses'),
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		amount_per_license: {
			required: Lang.get('extrax2-webadmin.required_amount_per_license')
		},
		voucher_code: {
			remote: Lang.get('extrax2-webadmin.invalid_voucher_code'),
			customMethod: Lang.get('extrax2-webadmin.invalid_voucher_code')
		},
		pvs_usage: {
			required: Lang.get('extrax2-webadmin.required_pvs_usage')
		},
		extraction_rate: {
			required: Lang.get('extrax2-webadmin.required_extraction_rate')
		},
		extraction_retrospective: {
			required: Lang.get('extrax2-webadmin.required_extraction_retrospective')
		},
		limited_use: {
			required: Lang.get('extrax2-webadmin.required_limited_use')
		},
		support_id: {
			required: Lang.get('extrax2-webadmin.required_support_id'),
			remote: Lang.get('extrax2-webadmin.invalid_support_id'),
			customMethod: Lang.get('extrax2-webadmin.invalid_support_id')
		},
		reminder_type: {
			required: Lang.get('extrax2-webadmin.required_reminder_type')
		},
		internal_or_external: {
			required: Lang.get('extrax2-webadmin.required_internal_or_external')
		},
		subject: {
			required: Lang.get('extrax2-webadmin.required_subject')
		},
		internal_recipient: {
			email: Lang.get('extrax2-webadmin.invalid_email'),
			required: Lang.get('extrax2-webadmin.required_internal_recipient')
		},
		external_recipient: {
			email: Lang.get('extrax2-webadmin.invalid_email')
		},
		email_address_sender: {
			email: Lang.get('extrax2-webadmin.invalid_email')
		},
		schedule_type: {
			required: Lang.get('extrax2-webadmin.required_schedule_type')
		},
		schedule_time: {
			required: Lang.get('extrax2-webadmin.required_schedule_time')
		},
		selection_months: {
			requiredWhenElementFilled: Lang.get('extrax2-webadmin.required_selection_months')
		},
		repeat_monthly: {
			requiredWhenElementFilled: Lang.get('extrax2-webadmin.required_repeat_monthly')
		},
		repeat_monthly_on_day_of_the_week: {
			requiredWhenElementFilled: Lang.get('extrax2-webadmin.required_repeat_monthly_on_day_of_the_week')
		},
		repeat_all_x_weeks: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			requiredWhenElementFilled: Lang.get('extrax2-webadmin.required_repeat_repeat_all_x_weeks')
		},
		selection_days: {
			requiredWhenElementFilled: Lang.get('extrax2-webadmin.required_selection_days')
		},
		repeat_all_x_days: {
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			requiredWhenElementFilled: Lang.get('extrax2-webadmin.required_repeat_all_x_days')
		},
		additional_interval_days: {
			min: Lang.get('extrax2-webadmin.positiv_integer_greater_null'),
			digits: Lang.get('extrax2-webadmin.positiv_integer_greater_null')
		},
		category: {
			required: Lang.get('extrax2-webadmin.required_category')
		},
		file_description: {
			required: Lang.get('extrax2-webadmin.required_file_description')
		},
		file_name: {
			required: Lang.get('extrax2-webadmin.required_file_name')
		},
		export_bsnr_hash_salt: {
			requiredWhenElementFilled: Lang.get('extrax2-webadmin.required_bsnr_hash_salt')
		},
		export_lanr_hash_salt: {
			requiredWhenElementFilled: Lang.get('extrax2-webadmin.required_lanr_hash_salt')
		},
		export_user_hash_salt: {
			requiredWhenElementFilled: Lang.get('extrax2-webadmin.required_user_hash_salt')
		}
	}

	return messages;
}

function getIgnore(element) {

	var ignore = ".select2-search__field";

	return ignore;
}

function addSummernoteData(data) {

	// Nachricht manuell hinzufügen
	if ($('.summernote').length) {
		$.each($('.summernote'), function(i, element) {
			data = data + "&" + $(element).attr('name') + "=" + encodeURIComponent($(element).code());
		});
	}

	return data;
}

function loadAuditTrail(form, data, originalData) {

	if (data !== 'wait' && !('too_many_result_rows' in data) && data !== 'FAILS') {
		showAuditTrail(data, form);
		return;
	}

	var action = form.action;
	action = action.substring(0, action.lastIndexOf('/')) + '/0';

	ajax.ajaxCall(action, 'GET', originalData, false, function (data) {

		if (data === 'wait') {

			setTimeout(function() {
				loadAuditTrail(form, data, originalData);
			}, 5000);

		} else {

			if (data !== 'FAILS' && !('too_many_result_rows' in data)) {
				showAuditTrail(data, form);
			} else if ('too_many_result_rows' in data) {

				App.unblockUI('body');

				bootbox.dialog({
					message: Lang.get('extrax2-webadmin.too_many_result_rows', { "rowCount": data['too_many_result_rows']}),
					title: Lang.get('extrax2-webadmin.load_audit_trail'),
					buttons: {
						ok: {
							label: Lang.get('extrax2-webadmin.ok'),
							className: "btn blue",
							callback: function() {

								ajax.ajaxCall('admin/audit_trail/delete/user/' + data['user_id'] + '/timestamp/' + data['time_stamp'], 'POST', '_method=DELETE', false, function (data) {
								});
							}
						}
					}
				});
			}
		}
	});
}

function showAuditTrail(data, form) {
	var userId = data['user_id'];
	var timeStamp = data['time_stamp'];

	ajax.ajaxCall('admin/audit_trail/result/user/' + userId + '/timestamp/' + timeStamp, 'GET', null, false, function (data) {
		$('#table_audit_trail').dataTable().api().clear().rows.add(data).draw();

		utils.setDetailPortletMaxHeight();
		utils.setPortletMaxHeight();

		App.unblockUI('body');

		$('[href="#tab_results"]').click();
		ajax.ajaxCall('admin/audit_trail/delete/user/' + userId + '/timestamp/' + timeStamp, 'POST', '_method=DELETE', false, function (data) {
		});
	});

	$('.tt-start-search-audit-trail').removeClass('disabled');
	$('.tt-start-search-audit-trail').prop('disabled', '');
}

// Geladene Daten anzeigen

function showContentData(data, element, form, validator, doInitializeElements) {

	if (!/^FAILS/.test(data)) {
		utils.setHtmlData($("#content"), data, doInitializeElements);
	}
}

function showDetailData(data, element, form, validator, doInitializeElements) {

	if (/^FAILS/.test(data)) {
		if (form.id === "table_users_detail_form") {
			validator.showErrors({ 'username': data.substring(6) });
		} else if (form.id === "table_facilities_detail_form") {
			data = data.substring(6);
			var splitted_data = data.split("|");

			jQuery.each(splitted_data, function (i, val) {

				if (/^ID/.test(val)) {
					validator.showErrors({ 'facilityid': val.substring(2) });
				} else if (/^Name/.test(val)) {
					validator.showErrors({ 'facilityname': val.substring(4) });
				}
			});
		} else if (form.id === "table_roles_detail_form") {
			validator.showErrors({ 'rolename': data.substring(6) });
		} else if (form.id === "table_data_collection_types_detail_form") {
			data = data.substring(6);
			var splitted_data = data.split("|");

			jQuery.each(splitted_data, function (i, val) {

				if (/^Model/.test(val)) {
					validator.showErrors({ 'model': val.substring(5) });
				} else if (/^Abbreviation/.test(val)) {
					validator.showErrors({ 'abbreviation': val.substring(12) });
				}
			});
		}
	} else {
		if ($('#content').find('.tt-content-datatable').length) {
			if (utils.GLOBALS.elementToClickAfterSave === null) {
				$('#content').find('.tt-content-datatable').find('.tt-datatable-search').val("");
				$('#content').find('.tt-content-datatable').find('.tt-datatable-search').removeClass('edited');
				$('#content').find('.tt-content-datatable').find('.tt-datatable').dataTable().fnFilterClear();
				$('#content').find('.tt-content-datatable').parents('.portlet').find('.tt-delete').addClass('disabled');
				$('#content').find('.tt-content-datatable').parents('.portlet').find('.tt-delete').prop('disabled', 'disabled');
			} else {
				$('#content').find('.tt-content-datatable').find('.tt-datatable').dataTable().fnStandingRedraw();
			}
		}
		utils.setHtmlData($("#content-detail"), data, doInitializeElements);
	}
}

function showNewDetailData(data, element, form, validator, doInitializeElements) {

	if (/^FAILS/.test(data)) {
		if (form.id === "table_users_create_form") {
			validator.showErrors({ 'username': data.substring(6) });
		} else if (form.id === "table_facilities_create_form") {
			data = data.substring(6);
			var splitted_data = data.split("|");

			jQuery.each(splitted_data, function (i, val) {

				if (/^ID/.test(val)) {
					validator.showErrors({ 'facilityid': val.substring(2) });
				} else if (/^Name/.test(val)) {
					validator.showErrors({ 'facilityname': val.substring(4) });
				}
			});
		} else if (form.id === "table_roles_create_form") {
			validator.showErrors({ 'rolename': data.substring(6) });
		} else if (form.id === "table_data_collection_types_create_form") {
			data = data.substring(6);
			var splitted_data = data.split("|");

			jQuery.each(splitted_data, function (i, val) {

				if (/^Model/.test(val)) {
					validator.showErrors({ 'model': val.substring(5) });
				} else if (/^Abbreviation/.test(val)) {
					validator.showErrors({ 'abbreviation': val.substring(12) });
				}
			});
		}
	} else {
		$('#content').find('.tt-content-datatable').parents('.portlet').find('.tt-delete').addClass('disabled');
		$('#content').find('.tt-content-datatable').parents('.portlet').find('.tt-delete').prop('disabled', 'disabled');
		$('#content').find('.tt-content-datatable').find('.tt-datatable').dataTable().$('tr.active').removeClass('active');
		element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
		utils.setHtmlData($("#content-detail"), data, doInitializeElements);
		$("#content-detail").find('form').addClass('dirty');
	}
}

function format (element) {
	if (!utils.isUndefined(element.element) && !utils.isUndefined($(element.element).data()) && !utils.isUndefined($(element.element).data().inactive) && $(element.element).data().inactive) {
		return '<span class="tt-option-inactive">' + element.text + '</span>';
	}
	return element.text;
}

function addListItem(elementId, data, form, prepend) {

	var newId = $(form).find('[name="new_id"]').val();
	if (prepend) {
		$('#' + elementId + ' .mt-list-container ul:not(.hide):not([class^=\'select2-selection\'])').prepend(data);
	} else {
		$('#' + elementId + ' .mt-list-container ul:not(.hide):not([class^=\'select2-selection\'])').append(data);
	}
	$('#' + elementId + ' .mt-list-container ul:not(.hide) .mt-list-item').removeClass('active');
	$('#' + elementId + ' .mt-element-list .tt-list-button').prop('disabled', 'disabled');
	initialize.initializeElements($('#' + elementId + ' .mt-list-container ul'));
	utils.setFormatValues($('#' + elementId + ' .mt-list-container ul:not(.hide) [data-table-id="' + newId + '"]'));
	utils.setDetailPortletMaxHeight();
	addListRules($('#' + elementId));
	$(form).find('[name="new_id"]').val(parseInt(newId) - 1);
	$(form).find('.tt-dialog-cancel').click();

	return newId;
}

// Aufrufe ohne Ajax

function setHistoryItemThresholdValues(form) {

	var listItem = $($('#tab_history_items').find('.mt-element-list .mt-list-container .mt-list-item.active')[0]);

	listItem.find('[name^="threshold_hits_min_for_warning_"]').val($('#threshold_hits_min_for_warning').val());
	listItem.find('[name^="threshold_hits_min_for_error_"]').val($('#threshold_hits_min_for_error').val());
	listItem.find('[name^="threshold_patients_with_hits_min_for_warning_"]').val($('#threshold_patients_with_hits_min_for_warning').val());
	listItem.find('[name^="threshold_patients_with_hits_min_for_error_"]').val($('#threshold_patients_with_hits_min_for_error').val());
	listItem.find('[name^="threshold_hits_rel_min_for_warning_"]').val($('#threshold_hits_rel_min_for_warning').val());
	listItem.find('[name^="threshold_hits_rel_min_for_error_"]').val($('#threshold_hits_rel_min_for_error').val());
	listItem.find('[name^="threshold_patients_with_hits_rel_min_for_warning_"]').val($('#threshold_patients_with_hits_rel_min_for_warning').val());
	listItem.find('[name^="threshold_patients_with_hits_rel_min_for_error_"]').val($('#threshold_patients_with_hits_rel_min_for_error').val());

	$('#table_licenses_history_item_thresholds_dialog').modal('hide');
}

function setHistoryItemTokenValues(form) {

	var listItem = $($('#tab_history_items').find('.mt-element-list .mt-list-container .mt-list-item.active')[0]);

	listItem.find('[name^="history_item_token_"]').remove();
	jQuery.each($(form).find('[name^="history_item_token_pvs_id_"]'), function (i, element) {
		$('<input type="hidden" name="' + element.name + '" value="' + $(element).select2().val() + '">').clone().prependTo(listItem.find('.row-editable'));
	});
	jQuery.each($(form).find('[name^="history_item_token_"]:not([name^="history_item_token_pvs_id_"])'), function (i, element) {
		$('<input type="hidden" name="' + element.name + '" value="' + $(element).val() + '">').clone().prependTo(listItem.find('.row-editable'));
	});

	listItem.find('[name^="tokens_listtype"]').val($('[name="tokens_listtype"]:checked').val());

	$('#table_licenses_history_item_tokens_dialog').modal('hide');
}

function setHistoryItemDefaultMaskExpressionValues(form) {

	var listItem = $($('#tab_history_items').find('.mt-element-list .mt-list-container .mt-list-item.active')[0]);

	listItem.find('[name^="mask_expression_"]').remove();
	jQuery.each($(form).find('[name^="mask_expression_pvs_id_"]'), function (i, element) {
		$('<input type="hidden" name="' + element.name + '" value="' + $(element).select2().val() + '">').clone().prependTo(listItem.find('.row-editable'));
	});
	jQuery.each($(form).find('[name^="mask_expression_ident_"],[name^="mask_expression_expression_"]'), function (i, element) {
		$('<input type="hidden" name="' + element.name + '" value="' + $(element).val() + '">').clone().prependTo(listItem.find('.row-editable'));
	});

	$('#table_licenses_history_item_default_mask_expressions_dialog').modal('hide');
}

function closeContract(form) {

	$('.tt-content').removeClass('hide');
	$('.tt-content-contract').addClass('hide');

	var listItem = $($('#tab_participant_bsnr_lanr').find('.mt-element-list .mt-list-container .mt-list-item.active')[0]);

	if (/^reseller_/.test($('#invoice_recipient').select2().val())) {
		listItem.find('[name^="invoice_recipient_"]').val('reseller');
		listItem.find('[name^="reseller_id_"]').val($('#invoice_recipient').select2().val().substr($('#invoice_recipient').select2().val().lastIndexOf('_') + 1));
	} else {
		listItem.find('[name^="invoice_recipient_"]').val($('#invoice_recipient').select2().val());
		listItem.find('[name^="reseller_id_"]').val('');
	}
	listItem.find('[name^="voucher_code_"]').val($('#voucher_code').val());
	if (utils.isUndefined($('#contract_date').data('picker').getDate())) {
		listItem.find('[name^="contract_date_"]').val('');
	} else {
		listItem.find('[name^="contract_date_"]').val(utils.dateToString($('#contract_date').data('picker').getDate()));
	}
	if (utils.isUndefined($('#start_date').data('picker').getDate())) {
		listItem.find('[name^="start_date_"]').val('');
		listItem.find('.tt-start-date').text('');
	} else {
		listItem.find('[name^="start_date_"]').val(utils.dateToString($('#start_date').data('picker').getDate()));
		listItem.find('.tt-start-date').text(utils.dateToLocaleString(utils.dateToString($('#start_date').data('picker').getDate())));
	}
	listItem.find('[name^="minimum_duration_"]').val($('#minimum_duration').val());
	listItem.find('[name^="duration_"]').val($('#duration').val());
	listItem.find('[name^="accounting_period_"]').val($('#accounting_period').val());
	listItem.find('[name^="maturity_"]').val($('#maturity').select2().val());
	listItem.find('[name^="reference_date_"]').val($('#reference_date').select2().val());
	listItem.find('[name^="notice_"]:not([name^="notice_date_"],[name^="notice_time_unit_"])').val($('#notice').val());
	listItem.find('[name^="notice_time_unit_"]').val($('#notice_time_unit').val());
	if (utils.isUndefined($('#notice_date').data('picker').getDate())) {
		listItem.find('[name^="notice_date_"]').val('');
	} else {
		listItem.find('[name^="notice_date_"]').val(utils.dateToString($('#notice_date').data('picker').getDate()));
	}
	if (utils.isUndefined($('#validity_date').data('picker').getDate())) {
		listItem.find('[name^="validity_date_"]').val('');
		listItem.find('.tt-validity-date').text('');
	} else {
		listItem.find('[name^="validity_date_"]').val(utils.dateToString($('#validity_date').data('picker').getDate()));
		listItem.find('.tt-validity-date').text(utils.dateToLocaleString(utils.dateToString($('#validity_date').data('picker').getDate())));
	}
	if (utils.isUndefined($('#last_export_date').data('picker').getDate())) {
		listItem.find('[name^="last_export_date_"]').val('');
	} else {
		listItem.find('[name^="last_export_date_"]').val(utils.dateToString($('#last_export_date').data('picker').getDate()));
	}
	listItem.find('[name^="customer_order_"]').val($('#customer_order').val());
	if ($('#first_commission_recipient').length) {
		listItem.find('[name^="first_commission_recipient_"]').val($('#first_commission_recipient').select2().val());
		listItem.find('[name^="first_commission_rate_"]').val($('#first_commission_rate').select2().val());
		listItem.find('[name^="second_commission_recipient_"]').val($('#second_commission_recipient').select2().val());
		listItem.find('[name^="second_commission_rate_"]').val($('#second_commission_rate').select2().val());
	}

	$('#tab_participant_bsnr_lanr').parents('form').validate().settings.rules = getRules($('#tab_participant_bsnr_lanr').parents('form'));
	addListRules($('#tab_participant_bsnr_lanr').parents('form'));
}

function closeCalculation(form) {

	$('.tt-content').removeClass('hide');
	$('.tt-content-calculation').addClass('hide');

	var listItem = $($('#' + $('#tab_name').val()).find('.mt-element-list .mt-list-container .mt-list-item.active')[0]);

	if (listItem.find('[name^="amount_per_period_and_participant_"]').length) {
		listItem.find('[name^="amount_per_period_and_participant_"]').val($('#c_amount_per_period_and_participant').val());
	}
	listItem.find('[name^="once_only_amount_"]').val($('#c_once_only_amount').val());

	if (listItem.find('[name^="from_number_of_lanr_bsnr_"]').length) {
		listItem.find('[name^="from_number_of_lanr_bsnr_"]').val($('#c_from_number_of_lanr_bsnr').val());
	}
	if (listItem.find('[name^="lanr_bsnr_"]').length) {
		listItem.find('[name^="lanr_bsnr_"]').removeAttr('checked');
		listItem.find('[name^="lanr_bsnr_"][value="' + $('[name="lanr_bsnr"]:checked').val() + '"]').prop('checked', true);
	}

	if (listItem.find('[name^="pvs_usage_"]').length) {
		listItem.find('[name^="pvs_usage_"]').val($('#c_pvs_usage').select2().val().join('|'));
	}
	if (listItem.find('[name^="extraction_rate_"]').length) {
		listItem.find('[name^="extraction_rate_"]').val($('#c_extraction_rate').select2().val());
	}
	if (listItem.find('[name^="extraction_retrospective_"]').length) {
		listItem.find('[name^="extraction_retrospective_"]').val($('#c_extraction_retrospective').select2().val());
	}
	if (listItem.find('[name^="limited_use_"]').length) {
		listItem.find('[name^="limited_use_"]').val($('#c_limited_use').select2().val());
	}
	if (listItem.find('[name^="payment_on_use_"]').length) {
		if ($('#c_payment_on_use').is(':checked')) {
			listItem.find('[name^="payment_on_use_"]').val('1');
		} else {
			listItem.find('[name^="payment_on_use_"]').val('0');
		}
	}
	if (listItem.find('[name^="first_level_support_"]').length) {
		if ($('#c_first_level_support').is(':checked')) {
			listItem.find('[name^="first_level_support_"]').val('1');
		} else {
			listItem.find('[name^="first_level_support_"]').val('0');
		}
	}
	if ($('#c_master_data').is(':checked')) {
		listItem.find('[name^="master_data_"]').val('1');
	} else {
		listItem.find('[name^="master_data_"]').val('0');
	}
	if ($('#c_birth_date').is(':checked')) {
		listItem.find('[name^="birth_date_"]').val('1');
	} else {
		listItem.find('[name^="birth_date_"]').val('0');
	}
	if ($('#c_iv_data').is(':checked')) {
		listItem.find('[name^="iv_data_"]').val('1');
	} else {
		listItem.find('[name^="iv_data_"]').val('0');
	}
	if ($('#c_insurance_data').is(':checked')) {
		listItem.find('[name^="insurance_data_"]').val('1');
	} else {
		listItem.find('[name^="insurance_data_"]').val('0');
	}
	if ($('#c_clinical_master_data').is(':checked')) {
		listItem.find('[name^="clinical_master_data_"]').val('1');
	} else {
		listItem.find('[name^="clinical_master_data_"]').val('0');
	}
	if ($('#c_insurance_certificate').is(':checked')) {
		listItem.find('[name^="insurance_certificate_"]').val('1');
	} else {
		listItem.find('[name^="insurance_certificate_"]').val('0');
	}
	if ($('#c_private_certificate').is(':checked')) {
		listItem.find('[name^="private_certificate_"]').val('1');
	} else {
		listItem.find('[name^="private_certificate_"]').val('0');
	}
	if ($('#c_misc_certificate').is(':checked')) {
		listItem.find('[name^="misc_certificate_"]').val('1');
	} else {
		listItem.find('[name^="misc_certificate_"]').val('0');
	}
	if ($('#c_form_data').is(':checked')) {
		listItem.find('[name^="form_data_"]').val('1');
	} else {
		listItem.find('[name^="form_data_"]').val('0');
	}
	if ($('#c_permanent_diagnosis').is(':checked')) {
		listItem.find('[name^="permanent_diagnosis_"]').val('1');
	} else {
		listItem.find('[name^="permanent_diagnosis_"]').val('0');
	}
	if ($('#c_diagnosis').is(':checked')) {
		listItem.find('[name^="diagnosis_"]').val('1');
	} else {
		listItem.find('[name^="diagnosis_"]').val('0');
	}
	if ($('#c_prescription_medication').is(':checked')) {
		listItem.find('[name^="prescription_medication_"]').val('1');
	} else {
		listItem.find('[name^="prescription_medication_"]').val('0');
	}
	if ($('#c_prescription_adjuvant').is(':checked')) {
		listItem.find('[name^="prescription_adjuvant_"]').val('1');
	} else {
		listItem.find('[name^="prescription_adjuvant_"]').val('0');
	}
	if ($('#c_prescription_remedies').is(':checked')) {
		listItem.find('[name^="prescription_remedies_"]').val('1');
	} else {
		listItem.find('[name^="prescription_remedies_"]').val('0');
	}
	if ($('#c_permanent_medication').is(':checked')) {
		listItem.find('[name^="permanent_medication_"]').val('1');
	} else {
		listItem.find('[name^="permanent_medication_"]').val('0');
	}
	if ($('#c_medication').is(':checked')) {
		listItem.find('[name^="medication_"]').val('1');
	} else {
		listItem.find('[name^="medication_"]').val('0');
	}
	if ($('#c_medication_plan').is(':checked')) {
		listItem.find('[name^="medication_plan_"]').val('1');
	} else {
		listItem.find('[name^="medication_plan_"]').val('0');
	}
	if ($('#c_medication_mapper').is(':checked')) {
		listItem.find('[name^="medication_mapper_"]').val('1');
	} else {
		listItem.find('[name^="medication_mapper_"]').val('0');
	}
	if ($('#c_lab_data').is(':checked')) {
		listItem.find('[name^="lab_data_"]').val('1');
	} else {
		listItem.find('[name^="lab_data_"]').val('0');
	}
	if ($('#c_clinical_course_data').is(':checked')) {
		listItem.find('[name^="clinical_course_data_"]').val('1');
	} else {
		listItem.find('[name^="clinical_course_data_"]').val('0');
	}
	if ($('#c_misc_data').is(':checked')) {
		listItem.find('[name^="misc_data_"]').val('1');
	} else {
		listItem.find('[name^="misc_data_"]').val('0');
	}
	if ($('#c_invoices').is(':checked')) {
		listItem.find('[name^="invoices_"]').val('1');
	} else {
		listItem.find('[name^="invoices_"]').val('0');
	}
	if ($('#c_invoices_insurance_association').is(':checked')) {
		listItem.find('[name^="invoices_insurance_association_"]').val('1');
	} else {
		listItem.find('[name^="invoices_insurance_association_"]').val('0');
	}
	if ($('#c_invoices_cancel_export').is(':checked')) {
		listItem.find('[name^="invoices_cancel_export_"]').val('1');
	} else {
		listItem.find('[name^="invoices_cancel_export_"]').val('0');
	}
	if ($('#c_invoices_insurance_association_cancel_export').is(':checked')) {
		listItem.find('[name^="invoices_insurance_association_cancel_export_"]').val('1');
	} else {
		listItem.find('[name^="invoices_insurance_association_cancel_export_"]').val('0');
	}
	if ($('#c_patient_contacts').is(':checked')) {
		listItem.find('[name^="patient_contacts_"]').val('1');
	} else {
		listItem.find('[name^="patient_contacts_"]').val('0');
	}
	if ($('#c_documentation').is(':checked')) {
		listItem.find('[name^="patient_contact_collection_type_"]').val('documentation');
	} else if ($('#c_accounting').is(':checked')) {
		listItem.find('[name^="patient_contact_collection_type_"]').val('accounting');
	} else {
		listItem.find('[name^="patient_contact_collection_type_"]').val('');
	}
	if ($('#c_patient_contact_dates').is(':checked')) {
		listItem.find('[name^="patient_contact_dates_"]').val('1');
	} else {
		listItem.find('[name^="patient_contact_dates_"]').val('0');
	}
	if ($('#c_count_patient_contacts').is(':checked')) {
		listItem.find('[name^="count_patient_contacts_"]').val('1');
	} else {
		listItem.find('[name^="count_patient_contacts_"]').val('0');
	}
	if ($('#c_ims_data').is(':checked')) {
		listItem.find('[name^="ims_data_"]').val('1');
	} else {
		listItem.find('[name^="ims_data_"]').val('0');
	}

	utils.setPortletMaxHeight();
	utils.setDetailPortletMaxHeight();
}

function checkForOneTimeUsage(use_default_account_settings, invoice_recipient, start_date, charging_by, reseller_id) {
	return $.Deferred(function (defer) {

		if (!use_default_account_settings && (invoice_recipient === 'participant' || invoice_recipient === 'participant_invoice')) {
			var isOneTimeUsage = false;
			var sortedList = [];

			$.each($('.tt-custom-accounting .mt-list-item'), function(i, element) {
				if ($(element).find('[name^="lanr_bsnr_"]:checked').val() === charging_by) {
					var validFrom = jQuery($(element).find('[name^="valid_from_"]')).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '');
					if (validFrom !== '') {
						var picker = $(element).find('[name^="valid_from_"]').data('picker');
						validFrom = picker.getDate();
					}
					var sortObject = {};
					sortObject.validFrom = validFrom;
					sortObject.extractionRate = $(element).find('[name^="extraction_rate_"]').val();
					sortedList.push(sortObject);
				}
			});

			sortedList.sort(function(a, b) {
				return b.validFrom - a.validFrom;
			});

			$.each(sortedList, function(i, element) {
				if (element.validFrom <= utils.stringToDate(start_date)) {
					if (element.extractionRate === 'one_time' || element.extractionRate === 'one_time_migration') {
						isOneTimeUsage = true;
					}
					return false;
				}
			});

			if (isOneTimeUsage) {
				$('.tt-one-time-usage').addClass('hide');
				$('#label_start_date').text(trans('extrax2-webadmin.purchase_date'));
			} else {
				$('.tt-one-time-usage').removeClass('hide');
				$('#label_start_date').text(trans('extrax2-webadmin.start_date'));
			}
			utils.setPortletMaxHeight();
			defer.resolve(isOneTimeUsage);
		} else {
			var data = 'use_default_account_settings=' + use_default_account_settings + '&invoice_recipient=' + invoice_recipient + '&start_date=' + start_date + '&charging_by=' + charging_by + '&reseller_id=' + reseller_id;

			ajax.ajaxCall($('#check_for_one_time_usage_url').val(), 'GET', data, false, function (isOneTimeUsage) {

				if (isOneTimeUsage === 'true') {
					$('.tt-one-time-usage').addClass('hide');
					$('#label_start_date').text(trans('extrax2-webadmin.purchase_date'));
				} else {
					$('.tt-one-time-usage').removeClass('hide');
					$('#label_start_date').text(trans('extrax2-webadmin.start_date'));
				}
				utils.setPortletMaxHeight();

				defer.resolve(isOneTimeUsage === 'true');
			});
		}
	}).promise();
}

function checkContracts(form) {
	return $.Deferred(function (defer) {

		// alle Verträge überprüfen, ob bei den Preisen die Einmalnutzung ausgewählt wurde (ist nur wichtig falls Vertrag vor den Preisen angelegt oder geändert wurde)
		if (form.id === 'table_participants_detail_form') {
			var bsnrLanrArray = [];
			var dupilcateBsnrLanr = false;
			var counter = 0;

			$.each($('#tab_participant_bsnr_lanr .mt-list-item'), function (i, element) {
				checkForOneTimeUsage($('[name="use_default_account_settings"]').is(':checked'), $(element).find('[name^="invoice_recipient_"]').val(), $(element).find('[name^="start_date_"]').val(), $('[name="charging_by"]:checked').val(), $(element).find('[name^="reseller_id_"]').val())
					.done(function (isOneTimeUsage) {
						counter++;

						if (isOneTimeUsage) {
							$(element).find('[name^="contract_date_"]').val('');
							$(element).find('[name^="minimum_duration_"]').val('');
							$(element).find('[name^="duration_"]').val('');
							$(element).find('[name^="accounting_period_"]').val('');
							$(element).find('[name^="maturity_"]').val('');
							$(element).find('[name^="notice_"]').val('');
							$(element).find('[name^="notice_time_unit"]').val();
							$(element).find('[name^="notice_date_"]').val('');
							$(element).find('[name^="validity_date_"]').val('');
							$(element).find('[name^="last_export_date_"]'.val(''));
						}

						var bsnrLanr = {
							'bsnr': $(element).find('[name^="bsnr_"]').val(),
							'lanr': $(element).find('[name^="lanr_"]').val(),
							'start_date': $(element).find('[name^="start_date_"]').val(),
							'validity_date': $(element).find('[name^="validity_date_"]').val()
						}
						$.each(bsnrLanrArray, function (index, value) {

							if (value['bsnr'] == bsnrLanr['bsnr'] && value['lanr'] == bsnrLanr['lanr'] && (
									((utils.isUndefined(value['validity_date']) || value['validity_date'] === '') && (utils.isUndefined(bsnrLanr['validity_date']) || bsnrLanr['validity_date'] === '')) ||
									(value['validity_date'] !== '' && (utils.isUndefined(bsnrLanr['validity_date']) || bsnrLanr['validity_date'] === '') && utils.stringToDate(value['validity_date']) > utils.stringToDate(bsnrLanr['start_date'])) ||
									((utils.isUndefined(value['validity_date']) || value['validity_date'] === '') && bsnrLanr['validity_date'] !== '' && utils.stringToDate(bsnrLanr['validity_date']) > utils.stringToDate(value['start_date'])) ||
									(value['validity_date'] !== '' && (utils.isUndefined(bsnrLanr['validity_date']) || bsnrLanr['validity_date'] === '') && (utils.stringToDate(value['validity_date']) > utils.stringToDate(bsnrLanr['start_date']) || utils.stringToDate(bsnrLanr['validity_date']) > utils.stringToDate(value['start_date'])))
								)) {
								dupilcateBsnrLanr = true;
							}
						});
						bsnrLanrArray.push(bsnrLanr);

						if (counter === $('#tab_participant_bsnr_lanr .mt-list-item').length) {
							defer.resolve(dupilcateBsnrLanr);
						}
					});
			});
		} else {
			defer.resolve(false);
		}

	}).promise();
}

module.exports.validatorMethods = validatorMethods;
module.exports.setValidationToForms = setValidationToForms;
module.exports.getRules = getRules;
module.exports.showValidationMessage = showValidationMessage;
module.exports.format = format;
module.exports.getFormData = getFormData;
module.exports.clickElement = clickElement;
module.exports.checkForOneTimeUsage = checkForOneTimeUsage;
